<template>
    <div class="corporate-text text-size-5">
        <div class="content mt rounded hidden-md-down overflow-hidden">
            <div class="pos-relative bg-default-1 aspect" style="padding-bottom: 24%">
                <img
                    :data-src="`https://chico-rei.imgix.net/images/hotsites/corporativo/bnr_b2b.png?auto=compress,format&q=65`"
                    class="img-responsive lazy lazy-fade"
                />

                <div
                    class="pos-absolute px-5 pos-center-y text-primary-5 py-5 d-flex flex-justify-center"
                >
                    <div>
                        <h1 class="mt-0">Chico Rei para Empresas</h1>
                        <p>
                            <strong>
                                Qualidade, sustentabilidade e impacto social aliados aos valores da
                                sua empresa!
                            </strong>
                        </p>
                        <p>
                            Toda a nossa estrutura à disposição para atender as necessidades de
                            quem,
                            <br />
                            literalmente, veste a camisa ;)
                        </p>
                    </div>
                </div>
            </div>

            <div
                class="hidden-sm-down d-flex flex-wrap flex-justify-center text-size-4 text-yanone py"
            >
                <template v-for="(item, i) in summary">
                    <a class="cursor-pointer" :key="i.ref" @click="scrollTo(item.ref)">{{
                        item.label
                    }}</a>
                    <template v-if="i === Math.floor(summary.length / 2)">
                        <div class="hidden-lg-down mx-2" :key="i.ref">&bull;</div>
                        <div class="hidden-lg-up" style="flex: 0 0 100%" :key="i.label"></div>
                    </template>
                    <div v-else-if="i < summary.length - 1" :key="i.label" class="mx-2">&bull;</div>
                </template>
            </div>
        </div>
        <div class="hidden-md-up">
            <div class="pos-relative bg-default-1 aspect" style="padding-bottom: 39.06%">
                <img
                    :data-src="`https://chico-rei.imgix.net/images/hotsites/corporativo/bnrmobile_b2b.png?auto=compress,format&q=655`"
                    class="img-responsive lazy lazy-fade"
                />

                <div
                    class="pos-absolute pos-center-y text-primary-5 py-5 d-flex flex-justify-center"
                >
                    <div class="content">
                        <h1 class="h2 my-0">
                            Chico Rei <br />
                            para Lojistas
                        </h1>
                    </div>
                </div>
            </div>

            <div class="content text-primary-5 py-4 d-flex flex-justify-center">
                <div>
                    <p>
                        <strong> Sem pepinos, sem dificuldades, jogo rápido ;) </strong>
                    </p>
                    <p>
                        Você faz o seu cadastro e já acessa as condições de compra como revenda
                        oficial Chico Rei!
                    </p>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="flex-grid">
                <div class="flex-md-10 flex-md-offset-1">
                    <!-- Form -->
                    <div class="cr-form-group form my-8" ref="form" id="form">
                        <!---->
                        <h3 class="text-center">
                            Faça já o seu cadastro e garanta os melhores produtos para a sua empresa
                        </h3>
                        <div id="collections-form" class="mt">
                            <div class="flex-grid flex-grid-stretch">
                                <div class="flex-xs-12 flex-md-12">
                                    <div class="cr-form-group">
                                        <label for="business">Empresa:</label>
                                        <input
                                            id="business"
                                            v-model="fields.business"
                                            type="text"
                                        />
                                        <label for="name">Nome do Contato:</label>
                                        <input id="name" v-model="fields.name" type="text" />
                                        <label for="email">Email:</label>
                                        <input id="email" v-model="fields.email" type="email" />
                                        <div class="text-center my-4">
                                            <input
                                                :disabled="submitted || submitting"
                                                :value="submitLabel"
                                                class="btn btn-lg btn-primary"
                                                type="submit"
                                                @click="submit"
                                            />
                                            <Alert :alert="errorAlert" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Contato Chico -->
                    <div class="my-8">
                        <div ref="signUp" class="anchor"></div>
                        <h3 class="text-center">Quer falar com a gente? Simbora ;)</h3>

                        <div class="bg-default-1 py-4">
                            <div class="max-width flex-grid" style="justify-content: center">
                                <div
                                    v-for="(contact, index) in contacts"
                                    :key="index"
                                    class="flex-md-3"
                                >
                                    <div
                                        class="section-text-box text-center bg-white px-4 py h-full d-flex flex-column flex-align-center rounded"
                                    >
                                        <h5 class="text-primary">
                                            <b>{{ contact.label }}</b>
                                        </h5>
                                        {{ contact.content }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Condições -->
                    <div class="my-8">
                        <div ref="conditions" class="anchor"></div>
                        <h2 ref="conditions" class="h1 text-center condicoes">Condições</h2>

                        <div class="flex-grid flex-align-stretch">
                            <div
                                v-for="(condition, index) in conditions"
                                :key="index"
                                class="flex-sm-6"
                            >
                                <div class="frame px py d-flex flex-align-center h-full">
                                    <div class="pos-relative mr" style="flex: 0 0 70px">
                                        <div class="aspect aspect-xs-1-1">
                                            <div class="rounded-full pos-absolute pos-all">
                                                <!-- <div
                                                    v-if="condition.img"
                                                    class="img-responsive corporate-condition-icon rounded-full w-full h-full"
                                                    :style="`background: url('${condition.icon}'); background-repeat: no-repeat;`"
                                                ></div> -->
                                                <img
                                                    class="img-responsive corporate-condition-icon rounded-full w-full h-full"
                                                    v-if="condition.img"
                                                    :src="condition.icon"
                                                />

                                                <i v-else :class="condition.icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <p v-for="(item, index) in condition.items" :key="index">
                                            <span v-if="item === 'Saiba mais!'">
                                                <a
                                                    href="/camisetas-mudam-o-mundo"
                                                    class="text-primary-5"
                                                    >{{ item }}</a
                                                >
                                            </span>
                                            <span v-else>{{ item }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-justify-center text-medium mt-4">
                            <!-- <p class="mx">* Necessita análise</p>
                            <p class="mx">** Sem análise</p> -->
                        </div>
                    </div>
                    <!-- Impacto Social a Cada Peça -->
                    <div class="my-8">
                        <div ref="social" class="anchor"></div>
                        <h2 class="h1 text-center">Impacto Social a Cada Peça</h2>

                        <div>
                            <div class="flex-grid flex-align-center">
                                <div class="flex-lg-5 flex-xl-4">
                                    <div class="pl">
                                        <p>
                                            Somos meio de transformação social e queremos que sua
                                            empresa entre nessa ciranda. Através do nosso selo
                                            “Camisetas Mudam o Mundo”, transformamos a nossa
                                            sociedade.
                                        </p>
                                        <p>
                                            Acreditamos no papel de empresas que acreditam em um
                                            capitalismo cada vez mais consciente, inclusivo e justo.
                                        </p>
                                        <a
                                            class="text-primary-5"
                                            href="/camisetas-mudam-o-mundo"
                                            target="_blank"
                                        >
                                            Conheça o nosso projeto</a
                                        >
                                    </div>
                                </div>
                                <div class="flex-lg-7 flex-xl-8">
                                    <div class="bg-default-1 aspect aspect-xs-16-9 rounded">
                                        <picture>
                                            <source
                                                media="(min-width: 768px)"
                                                :data-srcset="`https://chico-rei.imgix.net/images/hotsites/corporativo/impacto-social.JPG?auto=compress,format&q=65`"
                                            />
                                            <img
                                                :data-src="`https://chico-rei.imgix.net/images/hotsites/corporativo/impacto-social.JPG?auto=compress,format&q=65`"
                                                class="lazy lazy-fade"
                                            />
                                        </picture>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Camisetas que conectam -->
                    <div class="my-8">
                        <div ref="conexao" class="anchor"></div>
                        <h2 class="h1 text-center">Camisetas que Conectam</h2>

                        <div>
                            <div class="flex-grid flex-align-center">
                                <div class="flex-lg-7 flex-xl-8">
                                    <div class="bg-default-1 aspect aspect-xs-16-9 rounded">
                                        <picture>
                                            <source
                                                media="(min-width: 768px)"
                                                :data-srcset="`https://chico-rei.imgix.net/images/hotsites/corporativo/camisetas_conectam_conjunto.jpg?auto=compress,format&q=65`"
                                            />
                                            <img
                                                :data-src="`https://chico-rei.imgix.net/images/hotsites/corporativo/camisetas_conectam_conjunto.jpg?auto=compress,format&q=65`"
                                                class="lazy lazy-fade"
                                            />
                                        </picture>
                                    </div>
                                </div>
                                <div class="flex-lg-5 flex-xl-4">
                                    <div class="pl">
                                        <!-- <p>
                                        A busca por conexão, propósito e
                                        pertencimento extrapolaram as fronteiras dos
                                        negócios. Hoje, esse vínculo é fundamental
                                        na relação entre empresa e time. Somos
                                        feitos de pessoas e para pessoas, afinal.
                                    </p> -->
                                        <p>
                                            Com uma expertise de mais de 15 anos de ecommerce e
                                            centenas de milhares de clientes espalhados pelo mundo,
                                            a Chico Rei abre suas portas para a produção de
                                            camisetas corporativas.
                                        </p>
                                        <p>
                                            Agora a sua empresa pode materializar valores e
                                            propósito em produtos únicos, desenvolvidos de forma
                                            sustentável e com grande durabilidade para atender as
                                            necessidades de quem, literalmente, veste a camisa.
                                        </p>
                                        <!-- <p>
                                            <a
                                                class="text-primary-5 text-bold text-italic"
                                                href="/camisetas-mudam-o-mundo"
                                                target="_blank"
                                            >
                                                Conheça o nosso projeto
                                            </a>
                                        </p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Sobre a Chico Rei -->
                    <div class="my-8">
                        <div ref="history" class="anchor"></div>
                        <h2 class="h1 text-center">Sobre a Chico Rei</h2>

                        <div class="hidden-md-up">
                            <div class="aspect aspect-xs-16-9 bg-default-1 rounded">
                                <img
                                    :data-src="`https://chico-rei.imgix.net/images/hotsites/corporativo/sobre_chico_bg.jpg?auto=compress,format&q=65`"
                                    class="lazy lazy-fade"
                                />
                            </div>
                            <p>
                                Somos uma marca que alia criatividade e tecnologia para impactar
                                positivamente a vida de pessoas através da venda de produtos feitos
                                com responsabilidade socioambiental. Contamos com mais de meio
                                milhão de pessoas incríveis vestindo nossas camisetas, espalhadas
                                por mais de 3 mil cidades do Brasil e 30 países pelo mundo.
                                Enxergamos a camiseta como uma bandeira. Uma forma de expressão. Um
                                jeito pra lá de bacana de mostrar para o mundo os seus valores, no
                                que você acredita. Mais do que isso, temos um propósito sólido.
                                Nossas camisetas são sinônimo de produção sustentável, qualidade e
                                impacto social gerado a cada peça vendida. E agora, tudo isso está
                                disponível para a sua empresa!
                            </p>
                        </div>

                        <div
                            class="hidden-md-down pos-relative aspect aspect-xs-16-9 bg-default-1 rounded"
                        >
                            <img
                                :data-src="'https://chico-rei.imgix.net/images/hotsites/corporativo/sobre_chico_bg.jpg?auto=compress,format&q=65'"
                                class="lazy lazy-fade"
                            />
                            <div class="pos-absolute pos-bottom pos-right pos-left mb-4 mx-4">
                                <div class="pos-absolute pos-all bg-white fade-4 rounded"></div>
                                <p class="pos-relative py-4 px-4 my-0">
                                    Somos uma marca que alia criatividade e tecnologia para impactar
                                    positivamente a vida de pessoas através da venda de produtos
                                    feitos com responsabilidade socioambiental. Contamos com mais de
                                    meio milhão de pessoas incríveis vestindo nossas camisetas,
                                    espalhadas por mais de 3 mil cidades do Brasil e 30 países pelo
                                    mundo. Enxergamos a camiseta como uma bandeira. Uma forma de
                                    expressão. Um jeito pra lá de bacana de mostrar para o mundo os
                                    seus valores, no que você acredita. Mais do que isso, temos um
                                    propósito sólido. Nossas camisetas são sinônimo de produção
                                    sustentável, qualidade e impacto social gerado a cada peça
                                    vendida. E agora, tudo isso está disponível para a sua empresa!
                                </p>
                            </div>
                        </div>
                    </div>
                    <!-- Parceiros -->
                    <div class="my-8">
                        <div ref="badges" class="anchor"></div>
                        <h2 class="h1 text-center">Parceiros</h2>
                        <p class="text-center">
                            Guimarães Rosa falou e disse:
                            <strong>é junto dos bão que a gente fica mió!</strong>
                        </p>

                        <p class="text-center">
                            Ao longo de nossa história, fizemos muitos projetos em parceria com
                            pessoas e marcas <br />que endossam o nosso trabalho e o nosso
                            posicionamento.
                        </p>
                        <p class="text-center">Alguns nomes que fizeram história por aqui:</p>

                        <div class="text-center">
                            <ul class="flex-grid flex-align-stretch flex-align-center">
                                <li
                                    class="flex-sm-6 flex-md-4 flex-xs-6 flex-lg-3 d-flex flex-align-center flex-justify-center mt-5 mb-5"
                                    style="height: 100px"
                                    v-for="(partner, index) in partners"
                                    :key="index"
                                >
                                    <img
                                        class="image-partner px-4 py-4"
                                        :src="partner.imgUrl"
                                        alt="Logo"
                                        style="width: 100%"
                                    />
                                </li>
                            </ul>
                            <!-- <ul class="d-flex flex-spaced-fixed partners">
                                <li
                                    class="flex-item-grow"
                                    v-for="(partner, index) in partners"
                                    :key="index"
                                >
                                    <img :src="partner.imgUrl" alt="Logo" />
                                </li>
                            </ul> -->
                        </div>
                    </div>
                    <!-- Selos de Responsabilidade -->
                    <div class="my-8">
                        <div ref="badges" class="anchor"></div>
                        <h2 class="h1 text-center">Selos de Responsabilidade</h2>

                        <div
                            v-for="(badge, index) in badges"
                            :key="index"
                            class="frame my-4 flex-grid flex-align-center"
                        >
                            <div class="corporate-badge-img flex-lg-2 flex-xl-2">
                                <img
                                    :data-src="badge.image + '?auto=compress,format&q=65'"
                                    class="img-responsive px-4 py-4 lazy lazy-fade"
                                    style="width: 100%"
                                />
                            </div>
                            <p class="flex-lg-10 flex-xl-10">
                                {{ badge.text }}
                            </p>
                        </div>
                    </div>
                    <!-- Seção de cadastrar -->
                    <div class="my-6 text-center">
                        <div ref="signUp" class="anchor"></div>
                        <h2 class="h1">Junte-se a nós</h2>

                        <button class="btn btn-primary btn-xl" @click="showAndScrollForm">
                            Cadastre-se
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Alert from '../common/Alert';

    export default {
        name: 'BusinessToBusiness',

        components: { Alert },

        data: () => {
            return {
                showForm: false,
                fields: {
                    business: null,
                    name: null,
                    email: null,
                },
                submitting: false,
                submitted: false,
                errorAlert: {
                    message: null,
                    isError: true,
                },
                widhtImagesPartners: 250,
                conditions: [
                    {
                        icon: 'https://chico-rei.imgix.net/images/hotsites/b2b/icones/icone_precos_corporativo.png?auto=compress,format&q=65w=60',
                        items: ['Camisetas a partir de R$ 29,90'],
                        img: true,
                    },
                    {
                        icon: 'https://chico-rei.imgix.net/images/hotsites/b2b/icones/icone_frete_corporativo.png?auto=compress,format&q=65&w=60,"',
                        items: [
                            'Receba diretamente em sua empresa ou envie diretamente para as pessoas do seu time',
                        ],
                        img: true,
                    },
                    {
                        icon: 'https://chico-rei.imgix.net/images/hotsites/b2b/icones/icone_pedidominimo_corporativo.png?auto=compress,format&q=65&w=60',
                        items: ['Pedido mínimo de 20 camisetas por estampa'],
                        img: true,
                    },
                    {
                        icon: 'https://chico-rei.imgix.net/images/hotsites/b2b/icones/icone_algodao_corporativo.png?auto=compress,format&q=65w=60',
                        items: [
                            'Qualidade garantida: é o mesmo produto da Chico Rei',
                            'Camiseta 100% algodão',
                            'Estampa em serigrafia ou impressão digital',
                        ],
                        img: true,
                    },
                    {
                        icon: 'https://chico-rei.imgix.net/images/hotsites/b2b/icones/icone_camiseta_corporativo.png?auto=compress,format&q=65&w=60',
                        items: [
                            'Produção 100% sustentável',
                            'Algodão certificado com o selo BCI',
                            'Água tratada e lixo zero durante a produção',
                        ],
                        img: true,
                    },
                    {
                        icon: 'https://chico-rei.imgix.net/images/hotsites/b2b/icones/icone_camisetasmudamomundo_corporativo.png?auto=compress,format&q=65w=60',
                        items: ['Todo produto comprado gera impacto social. ', 'Saiba mais!'],
                        img: true,
                    },
                ],

                badges: [
                    {
                        image: 'https://chico-rei.imgix.net/images/site/2019/selos/algodao-sustentavel.png',
                        text: 'Todo o nosso algodão é registrado com o selo BCI (Better Cotton Initiative), garantindo sustentabilidade com ética para promover melhorias sociais, ambientais e econômicas. Reduzindo impactos ambientais na produção do algodão e estimulando a economia nas comunidades agrícolas.',
                    },
                    {
                        image: 'https://chico-rei.imgix.net/images/site/2019/selos/peta.svg',
                        text: 'Os produtos da linha de vestuário da Chico Rei não empregam qualquer tipo de exploração animal em seus processos de produção, seja nos componentes ou nas práticas. Isso tudo garantido e certificado por uma das maiores instituições de proteção animal no mundo.',
                    },
                    {
                        image: 'https://chico-rei.imgix.net/images/site/2019/selos/endeavor.png',
                        text: 'O programa Scale-Up Endeavor é uma plataforma de aceleração de empresas através de conexões que transformam empreendedores e negócios. Há 3 anos fazemos parte da rede mundial da Endeavor.',
                    },
                    {
                        image: 'https://chico-rei.imgix.net/images/site/2019/selos/eureciclo-colorido-2.svg',
                        text: 'Utilizamos o modelo de compensação ambiental para 100% das embalagens consumidas pela Chico Rei, gerando incentivos para elevar as taxas de reciclagem em todo o país.',
                    },
                ],

                summary: [
                    { label: 'Condições', ref: 'conditions' },
                    { label: 'Impacto Social', ref: 'social' },
                    { label: 'Conexão', ref: 'conexao' },
                    { label: 'Selos de Responsabilidade', ref: 'badges' },
                    { label: 'Nossa História', ref: 'history' },
                    { label: 'Cadastre-se', ref: 'form' },
                ],
                partners: [
                    {
                        imgUrl: `https://chico-rei.imgix.net/images/site/parceiros/logos/74b84400-d022-11ea-8d8e-bb2284d31cea.png?fit=max&h=200&w=210`,
                    },
                    {
                        imgUrl: `https://chico-rei.imgix.net/images/site/parceiros/logos/ecfe23a0-f9b0-11ea-b59c-8b7b01a927ab.png?fit=max&h=200&w=210`,
                    },
                    {
                        imgUrl: `https://chico-rei.imgix.net/images/site/parceiros/logos/c064c010-f9b0-11ea-ae75-3370f32935e9.png?fit=max&h=200&w=210`,
                    },
                    {
                        imgUrl: `https://chico-rei.s3.amazonaws.com/images/site/parceiros/logos/frida-selo.png?fit=max&h=100&w=100`,
                    },
                    {
                        imgUrl: `https://chico-rei.s3.amazonaws.com/images/site/parceiros/logos/boticario.png?fit=max&h=200&w=210`,
                    },
                    {
                        imgUrl: `https://chico-rei.s3.amazonaws.com/images/site/parceiros/logos/logo_rockinrio.png?fit=max&h=200&w=210`,
                    },
                    {
                        imgUrl: `https://chico-rei.s3.amazonaws.com/images/site/parceiros/logos/logo-telecine.png?fit=max&h=200&w=210`,
                    },
                    {
                        imgUrl: `https://chico-rei.s3.amazonaws.com/images/site/parceiros/logo-vtex.png?fit=max&h=200&w=210`,
                    },
                ],
                contacts: [
                    {
                        label: 'Whatsapp',
                        content: '(32) 99920-0409',
                    },
                    {
                        label: 'E-mail',
                        content: 'vendas@chicorei.com.br',
                    },
                    {
                        label: 'Telefone',
                        content: '(32) 99920-0409',
                    },
                ],
            };
        },

        computed: {
            submitLabel() {
                if (this.submitted) {
                    return 'Enviado';
                } else if (this.submitting) {
                    return 'Enviando...';
                } else {
                    return 'Enviar';
                }
            },
        },

        methods: {
            scrollTo(ref) {
                cr$.byEl(this.$refs[ref]).scrollIntoView();
            },

            submit() {
                this.submitting = true;
                this.axios.api
                    .post('/email/b2b', this.fields)
                    .then(() => {
                        this.showSuccess(
                            'Seus dados foram enviados com sucesso e entraremos em contato em breve :)',
                            true
                        );
                        this.submitted = true;
                    })
                    .catch(() => {
                        this.showError(
                            'Não foi possível enviar as informações. Por favor, tente novamente.'
                        );
                    })
                    .then(() => (this.submitting = false));
            },
            showSuccess(message, persist) {
                if (persist) {
                    this.errorAlert = {
                        message,
                        isError: false,
                        timeout: 0,
                    };
                } else {
                    this.errorAlert = {
                        message,
                        isError: false,
                    };
                }
            },
            showError(message) {
                this.errorAlert = {
                    message,
                    isError: true,
                };
            },

            showAndScrollForm() {
                this.scrollTo('form');
            },
        },
    };
</script>
